const FilledInfoIcon = (props) => {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" {...props}>
      <path
        d="M9.333 3.37c-2.278 0.219 -4.328 1.656 -5.333 3.738 -1.6 3.312 -0.209 7.291 3.108 8.893a6.625 6.625 0 0 0 5.785 0 6.683 6.683 0 0 0 3.773 -6A6.675 6.675 0 0 0 9.333 3.37m0.95 3.352c0.307 0.105 0.55 0.448 0.55 0.778 0 0.439 -0.394 0.833 -0.833 0.833 -0.202 0 -0.434 -0.099 -0.584 -0.249a0.82 0.82 0 0 1 0.001 -1.169 0.817 0.817 0 0 1 0.867 -0.193m0.054 2.763c0.067 0.042 0.157 0.135 0.2 0.205l0.079 0.128v3.711l-0.101 0.143c-0.138 0.197 -0.288 0.278 -0.516 0.278s-0.378 -0.082 -0.516 -0.278l-0.101 -0.143V9.817l0.077 -0.124c0.194 -0.313 0.576 -0.403 0.877 -0.208"
        fillRule="evenodd"
      />
    </svg>
  );
};

export { FilledInfoIcon };
